import { proxy } from 'valtio';

/** The two surfaces that render pothole markers; they never mount at the same time. */
export type PotholeSurface = 'tab' | 'layer';

/**
 * Which pothole / manhole record is open, held outside the marker list so the URL and the table can
 * open one too. Its own module because both parents — the Potholing tab and the Site Data map layer
 * — need it, and neither should import the other's page.
 *
 * Scoped to a project: this outlives any component, so without `setProject` a record opened in one
 * project would still be open on arrival at the next, and get written into that project's URL.
 * Tagged with the surface that opened it for the same reason: a record opened on the Site Data
 * layer must not spring open on the Potholing tab, or the other way round.
 */
export const potholeOpenItemStore = proxy<{
  projectId: string | null;
  openItemId: string | null;
  surface: PotholeSurface | null;
}>({
  projectId: null,
  openItemId: null,
  surface: null,
});

/** Sets the project, dropping any selection left over from a different one. Safe on every render. */
export function setProject(projectId: string) {
  if (potholeOpenItemStore.projectId !== projectId) {
    potholeOpenItemStore.projectId = projectId;
    closePothole();
  }
}

export function openPothole(id: string, surface: PotholeSurface) {
  potholeOpenItemStore.openItemId = id;
  potholeOpenItemStore.surface = surface;
}

export function closePothole() {
  potholeOpenItemStore.openItemId = null;
  potholeOpenItemStore.surface = null;
}

/** Closes the record only if `surface` opened it; for a surface's unmount, so it never closes another's. */
export function releaseSurface(surface: PotholeSurface) {
  if (potholeOpenItemStore.surface === surface) closePothole();
}
